import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Button, Card} from 'react-bootstrap';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

function ResetPassword() {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [resetSuccess, setResetSuccess] = useState(null);
  const [resetError, setResetError] = useState(null);
  const { token } = useParams();
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

   const CF_BASE = "https://d2b3xd88n081z3.cloudfront.net";

  const handleResetPassword = async (event) => {
    event.preventDefault();

    if (newPassword !== confirmPassword) {
      setResetError("Passwords don't match.");
      setResetSuccess(null);
      return;
    }

    try {
      const response = await fetch(`https://bkf.onrender.com/passwordRoutes/${token}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ newPassword }),
      });

      if (!response.ok) {
        throw new Error('Password reset failed');
      }

      setResetSuccess('Your password has been successfully reset!');
      setResetError(null);
    } catch (e) {
      setResetError('Failed to reset password');
      setResetSuccess(null);
    }
  };

  return (
    <div  style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
               <video
                                    autoPlay
                                    loop
                                    muted
                                    playsInline
                                    style={{
                                      position: 'fixed',
                                      top: 0,
                                      left: 0,
                                      width: '100%',
                                      height: '100%',
                                      objectFit: 'cover',
                                      zIndex: -1,
                                    }}
                                      >
                                        <source src={`${CF_BASE}/public/backgroundgrey2.mp4`} />
                                        Your browser does not support the video tag.
                                      </video>
      <form onSubmit={handleResetPassword}>
        <Card className="card-body"
          style={{
            overflow: 'hidden',
            boxSizing: 'border-box',
            marginTop: '50%',
            width: '100%',
            marginBottom: '50%',
            position: 'relative',
            color: 'white',
            borderRadius: '10px'
          }}>

          <div>
          <h1 className='container col-12 justify-content-center password-heading2'>Password Reset</h1>
          {resetSuccess ? (
            <>
            <p className='container col-12 justify-content-center'
            style={{ fontSize: '1.2rem' }}>{resetSuccess}</p>
              <p className='container col-12 justify-content-center'
              style={{ textAlign: 'center',}}
              >
                Go to
                 <Link to="/Login"
                  style={{
                    color: 'white',
                    fontWeight: 'bold', 
                    textDecoration: 'none'
                    }}
                  > Login</Link>
                </p>
            </>

  ) : (
    <>
<div className='container col-12 justify-content-center'>
  <label htmlFor="newPassword"></label>

  <h2>New Password</h2>

  <div style={{ position: 'relative', width: '100%' }}>
    <input
      className='form-control about-card-edit'
      style={{
        background: 'none',
        border: 'none',
        color: 'silver',
        caretColor: 'grey',
        width: '100%',
        maxWidth: '100%',
        marginBottom: '10px',
        boxSizing: 'border-box',
         fontSize: "clamp(1rem, 1.8vw, 1.5rem)",
        paddingRight: '40px', // 👈 space for icon
      }}
      type={showNewPassword ? "text" : "password"}
      id="newPassword"
      value={newPassword}
      onChange={(e) => setNewPassword(e.target.value)}
      required
    />

    {/* 👇 Toggle Button */}
    <button
      type="button"
      onClick={() => setShowNewPassword(!showNewPassword)}
      style={{
        position: 'absolute',
        right: '10px',
        top: '50%',
        transform: 'translateY(-50%)',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        color: 'silver',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <span
        className="eye-icon"
        style={{
          fontSize: "clamp(1rem, 1.8vw, 1.5rem)",
          display: 'flex',
          alignItems: 'center',
          transition: 'transform 0.2s ease, opacity 0.2s ease'
        }}
      >
        {showNewPassword ? <FaEyeSlash /> : <FaEye />}
      </span>
    </button>
  </div>
</div>

<div className='container col-12 justify-content-center'>
  <label htmlFor="confirmPassword"></label>

  <h2>Confirm Password</h2>

  <div style={{ position: 'relative', width: '100%' }}>
    <input
      className='form-control about-card-edit'
      style={{
        background: 'none',
        border: 'none',
        color: 'silver',
        caretColor: 'grey',
        width: '100%',
        maxWidth: '100%',
        marginBottom: '10px',
        boxSizing: 'border-box',
         fontSize: "clamp(1rem, 1.8vw, 1.5rem)",
        paddingRight: '40px', // 👈 space for icon
      }}
      type={showConfirmPassword ? "text" : "password"}
      id="confirmPassword"
      value={confirmPassword}
      onChange={(e) => setConfirmPassword(e.target.value)}
      required
    />

    {/* 👇 Toggle Button */}
    <button
      type="button"
      onClick={() => setShowConfirmPassword(!showConfirmPassword)}
      style={{
        position: 'absolute',
        right: '10px',
        top: '50%',
        transform: 'translateY(-50%)',
        background: 'none',
        border: 'none',
        cursor: 'pointer',
        color: 'silver',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <span
        className="eye-icon"
        style={{
          fontSize: "clamp(1rem, 1.8vw, 1.5rem)",
          display: 'flex',
          alignItems: 'center',
          transition: 'transform 0.2s ease, opacity 0.2s ease'
        }}
      >
        {showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
      </span>
    </button>
  </div>
</div>
  {resetError && <p className='container col-12 justify-content-center' style={{ color: 'red' }}>{resetError}</p>}
     <div
     style={{
        display: 'flex',
        justifyContent: 'center',
        marginTop: '20px', 
      }}
     >
    <Button 
    type="submit"
    className="process-card-text hover-brighten"
    style={{
      marginTop: '1.5vmin',
      backgroundColor: 'rgb(67, 66, 66)',
      border: 'none',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
    <h2 style={{ margin: '1%'}}>Reset Password</h2>
    </Button>
     </div>
      </>
      )}
    </div>
        </Card>
      </form>
    </div>
  );
}

export default ResetPassword;
